import { Component, ChangeDetectionStrategy } from '@angular/core';
import { DeveloperInsightSectionComponent } from '../developer-insight-section';

@Component({
  selector: 'app-developer-overview',
  templateUrl: './developer-overview.component.html',
  styleUrls: ['./developer-overview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeveloperOverviewComponent extends DeveloperInsightSectionComponent {
  data: any;

  constructor() {
    super();
    this._developerStateService.developer$.subscribe(data => {
      this.data = data?.riskOverview;
    });
  }
}
